const TetherCnt = {
  symbol: "DAI",
  name: "Dai",
  meta: {
    title: "Buy Dai | Sell Dai | Dai prices and charts",
    description:
      "Dai Digital Currency is a fixed-price, dollar-backed digital currency. Dye's goal is to make each Dye equal to $ 1 forever. Buy and sell Dai currency code at the best price, lowest commission and fastest time in coinnik Market.",
    keywords: "Dai, buy Dai, sell Dai, Dai price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: " چگونه رمز ارز دای بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید بایننس کوین کنید. قیمت رمز ارز دای در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول رمز ارز دای کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "چون دای بر روی بلاک چین اتریوم قرار دارد، می‌توانید از تمامی کیف‌پول‌هایی که از اتریوم پشتیبانی می‌کنند برای دای استفاده کنید. کیف‌پول‌های تراست ولت، متامسک، اتمیک و ... برای نگهداری استیبل کوین دای گزینه مناسبی هستند.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین‌نیک مارکت می‌توان رمز ارز دای را نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "از استیبل کوین‌ها برای سرمایه‌گذاری استفاده نمی‌شود و بیشتر برای حفظ سرمایه و تبدیل کردن رمز ارزها، در مواقع سقوط بازار استفاده می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "آیا رمز ارز دای ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "از استیبل کوین‌ها برای سرمایه‌گذاری استفاده نمی‌شود و بیشتر برای حفظ سرمایه و تبدیل نکردن رمز ارزها، در مواقع سقوط بازار استفاده می‌شود. البته اگر به فکر سرمایه‌گذاری در دلار، آن هم به صورت دیجیتالی هستید، دای گزینه خوبی‌ست.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Dai",
      answer:
        "In coinnik Market trading platform, you can buy Dai currency code with Shetab member bank card and the lowest fee. The price of Dai currency code in Quinnic Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best Dai wallet?",
      answer: "Dai_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Dai at coinnik Market?",
      answer: "Keep_Dai_description",
      id: "toggler3",
    },
    {
      question: "Is Dai worth the investment?",
      answer: "Dai_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Dai",
        subTitle: "What is Dai?",
        content: "Dai_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Dai",
        content: "Dai_history_description",
        btnTitle: "Buy and sell Dai",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle: "Buy and sell Dai without intermediaries in coinnik Market",
        subTitle: "Buy Dai",
        content: "Buy_Dai_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Dai",
        content: "Sell_Dai_description",
        btnTitle: "Buy and sell Dai",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Dai analysis on the blog",
  informationTitle: "Dai market statistics and information",
};

export default TetherCnt;
